import BatchDetailsReportIndex from "@/Reports/BatchDetailsReportIndex.vue";
import BatchesReportContainer from "@/Reports/BatchesReportContainer.vue";

export default [
  {
    path: "/accounting/batches",
    name: "BatchesReportContainer",
    component: BatchesReportContainer,
    meta: {
      permissionRoles: ["batches_report"]
    }
  },
  {
    path: "/accounting/batches/:id",
    name: "BatchDetailsReport",
    component: BatchDetailsReportIndex,
    meta: {
      permissionRoles: ["batches_report"]
    }
  }
];
